export const HOLD_DOWN_DELAY = 200;

export const PAN_ZOOM = 'panZoom';

export const SELECT = 'select';
